import React from 'react'
import './style.scss'
import bem from '../../helpers/bem'

const Card = (props) => {
  const {
    rank,
    suit,
    active,
    addCardToBoard,
    updateActiveField,
    updateActiveFieldDelay,
    player,
    removeCard,
    type,
    result,
    board,
    setChosenCard,
    handId,
    chosen,
    menu,
    menuState,
    setCardsMenu,
    disable,
    setDisableCards,
    isResult,
  } = props;
  const block = 'card';

  const cardOnclick = () => {
    if (!active && menu) {
      addCardToBoard(rank, suit, active, setCardsMenu);
      if (updateActiveFieldDelay) {
        setDisableCards(true);
        setTimeout(() => {
          updateActiveField();
          setDisableCards(false);
        }, 500);
      } else {
        updateActiveField();
      }
    }
    if ((player || board || menuState) && !disable) {
      removeCard(rank, suit, type);
      setChosenCard(type, handId);
    }
    if (board && !disable) {
      updateActiveField()
    }
  };

  const shirtOnClick = () => {
    if (!disable) {
      setChosenCard(type, handId);
      if (board) updateActiveField();
    }
  };

  const getRankItemMods = () => {
    return {
      [rank.name]: true,
      [suit.color]: true,
    }
  };

  const getSuitItemMods = () => {
    return {
      [suit.name]: true,
    }
  };

  const getCardMods = () => {
    return {
      'active': !!active,
      'player': !!player,
      'board': !!board,
      'result': !!result,
      'chosen': !!chosen,
      'menu': !!menu,
      'menu-state': !!menuState,
      'is-result': !!isResult,
      'disable': !!disable,
    }
  };

  const getShirtMods = () => {
    return {
      'shirt': true,
      'board': !!board,
      'chosen': !!chosen,
      'menu-state': !!menuState,
      'disable': !!disable,
    }
  };

  return (suit && rank)
    ? (
      <div
        className={bem({block, mods: getCardMods()})}
        onClick={cardOnclick}
      >
        <div className={bem({block, elem: 'wrapper'})}>
          <div className={bem({block, elem: 'rank-wrapper'})}>
            <div className={bem({block, elem: 'rank-item', mods: getRankItemMods()})}/>
          </div>
          <div className={bem({block, elem: 'suit-wrapper'})}>
            <div className={bem({block, elem: 'suit-item', mods: getSuitItemMods()})}/>
          </div>
        </div>
      </div>
    ) : (
      <div
        className={bem({block, mods: getShirtMods()})}
        onClick={shirtOnClick}
      />
    )
};

export default Card;